import each from "lodash/each";

function ReadMore() {
  const readMore = document.getElementsByClassName("readMore");

  if (!readMore.length) return;

  each(readMore, item => {
    const btn = item.querySelector(".readMore__btn");
    const text = item.querySelector(".readMore__text");

    if (!btn || !text) return;

    btn.addEventListener("click", e => {
      e.preventDefault();
      text.style.display = "block";
      btn.style.display = "none";
    });
  });
}

export default ReadMore;
